// src/components/Intro1.jsx
import React, { useEffect, useState } from "react";
import HeroSection from "./HeroSection";
import ServicesSection from "./ServicesSection";
import ContactSection from "./ContactSection";
import WhyChoose from "./WhyChoose1";
import AboutSection from "./AboutSection";
import Experience from "./Experience1";

export default function Intro1() {
  useEffect(() => {
    ["/tech1.jpg", "/tech2.jpg", "/tech3.jpg"].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const services = [
    {
      id: "servicenow",
      icon: "/service-now.jpg",
      title: "ServiceNow",
      desc: "Empower your digital transformation journey with our ServiceNow specialists.",
      link: "/contact",
    },
    {
      id: "apps-development",
      icon: "/mob1.jpg",
      title: "Apps Development",
      desc: "Custom mobile solutions that deliver tangible business results.",
      link: "/services",
    },
    {
      id: "web-development",
      icon: "/web2.jpg",
      title: "Custom Web Application",
      desc: "Create user-friendly, fast, and secure websites.",
      link: "/services",
    },
    {
      id: "ecommerce",
      icon: "/E-commerce.jpg",
      title: "E-Commerce",
      desc: "We build secure, scalable, and user-friendly E-Commerce platforms.",
      link: "/services",
    },
    {
      id: "salesforce",
      icon: "/salesforce.avif",
      title: "Salesforce",
      desc: "Streamline sales, marketing, and customer support with custom Salesforce solutions.",
      link: "/services",
    },
    {
      id: "staff-augmentation",
      icon: "/staff.png",
      title: "Staff Augmentation",
      desc: "Get skilled IT professionals on-demand to scale your team efficiently.",
      link: "/services",
    },
  ];

  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <>
      <HeroSection />
      <ServicesSection services={services} />
      <WhyChoose/>
      <Experience />
      <AboutSection />
      {/* <ServicesSection services={services} /> */}
    </>
  );
}
